module.exports = __webpack_public_path__ + "img/_Cole.e042152b.png";